import {
  applyAdvanceAnnouncement,
  applyCompleteRound,
  applyConfirmRolePeek,
  applyDealCards,
  applyLockSeatOrder,
  applyLockVote,
  applyResolveVote,
  applyRevealCard,
  applySelectRoles,
  applySetDiscussionDuration,
  applyStartNextRound,
  applyStartNight,
  applyStartVote,
  applySubmitNightAction,
  applyTickDiscussion,
  applyTickVote,
  applyUpdateSeatOrder,
  type GameState,
  type OneNightAction,
  type ValidationResult,
  validateAdvanceAnnouncement,
  validateCompleteRound,
  validateConfirmRolePeek,
  validateDealCards,
  validateLockSeatOrder,
  validateLockVote,
  validateResolveVote,
  validateRevealCard,
  validateSelectRoles,
  validateSetDiscussionDuration,
  validateStartNextRound,
  validateStartNight,
  validateStartVote,
  validateSubmitNightAction,
  validateTickDiscussion,
  validateTickVote,
  validateUpdateSeatOrder,
} from "@cloudnest/one-night-ultimate-werewolf-engine";

// Explicit type → (validator, applier) routing. The engine exposes no single
// reducer, and `LockVoteAction.type` is a union, so routing is by explicit
// mapping — mirrors apps/game-validator and the v2 rules service.
export function validateOneNightAction(
  state: GameState,
  action: OneNightAction,
): ValidationResult {
  switch (action.type) {
    case "selectRoles":
      return validateSelectRoles(state, action);
    case "updateSeatOrder":
      return validateUpdateSeatOrder(state, action);
    case "lockSeatOrder":
      return validateLockSeatOrder(state, action);
    case "dealCards":
      return validateDealCards(state, action);
    case "confirmRolePeek":
      return validateConfirmRolePeek(state, action);
    case "startNight":
      return validateStartNight(state, action);
    case "advanceAnnouncement":
      return validateAdvanceAnnouncement(state, action);
    case "submitNightAction":
      return validateSubmitNightAction(state, action);
    case "setDiscussionDuration":
      return validateSetDiscussionDuration(state, action);
    case "tickDiscussion":
      return validateTickDiscussion(state, action);
    case "startVote":
      return validateStartVote(state, action);
    case "lockVote":
    case "castVote":
      return validateLockVote(state, action);
    case "tickVote":
      return validateTickVote(state, action);
    case "resolveVote":
      return validateResolveVote(state, action);
    case "revealCard":
      return validateRevealCard(state, action);
    case "completeRound":
      return validateCompleteRound(state, action);
    case "startNextRound":
      return validateStartNextRound(state, action);
  }
}

export function applyOneNightAction(
  state: GameState,
  action: OneNightAction,
): GameState {
  switch (action.type) {
    case "selectRoles":
      return applySelectRoles(state, action);
    case "updateSeatOrder":
      return applyUpdateSeatOrder(state, action);
    case "lockSeatOrder":
      return applyLockSeatOrder(state, action);
    case "dealCards":
      return applyDealCards(state, action);
    case "confirmRolePeek":
      return applyConfirmRolePeek(state, action);
    case "startNight":
      return applyStartNight(state, action);
    case "advanceAnnouncement":
      return applyAdvanceAnnouncement(state, action);
    case "submitNightAction":
      return applySubmitNightAction(state, action);
    case "setDiscussionDuration":
      return applySetDiscussionDuration(state, action);
    case "tickDiscussion":
      return applyTickDiscussion(state, action);
    case "startVote":
      return applyStartVote(state, action);
    case "lockVote":
    case "castVote":
      return applyLockVote(state, action);
    case "tickVote":
      return applyTickVote(state, action);
    case "resolveVote":
      return applyResolveVote(state, action);
    case "revealCard":
      return applyRevealCard(state, action);
    case "completeRound":
      return applyCompleteRound(state, action);
    case "startNextRound":
      return applyStartNextRound(state, action);
  }
}
